import { Component, OnInit, Injectable, Inject, Input, forwardRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '@angular/synthrone-design/services/api/api.service';
import { CookieService } from '@angular/synthrone-design/services/cookie/cookie.service';
import { MatDialog } from '@angular/material';
import { MessagesService } from '@angular/synthrone-design/services/messages/messages.service';
import { DefaultServiceSDK } from 'ms-system-angular-sdk';

@Component({
  selector: 'adminer-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

@Injectable()
export class LoginViewComponent implements OnInit {

  username: string;
  password: string;
  returnUrl: string;
  public messageError: string;
  public isSubmitting: boolean;
  public redirecting: boolean;

  @Input() loginFn: Function;
  @Input() getAssets: Function;
  @Input() appName: string;
  @Input() logo: string;
  @Input() background: string;

  constructor(private route: ActivatedRoute,
    private systemService: DefaultServiceSDK,
    private router: Router,
    private messagesService: MessagesService,
    private cookieService: CookieService,
    @Inject(forwardRef(() => ApiService)) private api: ApiService,
    protected dialog: MatDialog) {
    this.messageError = '';
    this.isSubmitting = false;
    this.logo = this.logo || 'https://placeholder.synthrone.com/cdn/images/logo/1.0.0/synthrone-logo.png';
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login() {
    this.messageError = '';
    this.isSubmitting = true;

    return this.systemService.adminerAuthenticatePost({
      email: this.username,
      password: this.password
    }).catch((error: any) => {
      this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
        this.messagesService.showSnack(parsedError, 'error');
      });
      this.isSubmitting = false;
      return Observable.throw(error);
    }).subscribe(res => {
      this.cookieService.setCookie('systemToken', res['token'], false, true);

      this.isSubmitting = false;
      this.redirecting = true;
      setTimeout(() => {
        if (/^[a-z][a-z0-9+.-]*:/.test(this.returnUrl)) {
          window.location.href = this.returnUrl;
        } else {
          this.router.navigateByUrl(this.returnUrl);
        }
      }, 500);
    })

  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/login/login.component.ts